import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PedidoPedidoListModule } from '../../../../pedido/pedido/list';
import { CampanhaPedidoNaoLiberadoViewComponent } from './campanha-pedido-nao-liberado-view.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoPedidoListModule
    ],
    declarations: [
        CampanhaPedidoNaoLiberadoViewComponent
    ],
    exports: [
        CampanhaPedidoNaoLiberadoViewComponent
    ]
})
export class CampanhaPedidoNaoLiberadoViewModule { }
